module.exports = __webpack_public_path__ + "files/0634c2f24d7e756e7e6dddac9f48417a.png";